import { NativeModules } from 'react-native';

const { Esewa } = NativeModules;

export default Esewa;